import { render, staticRenderFns } from "./PipelinePhaseLabel.vue?vue&type=template&id=e9a2bf22&"
import script from "./PipelinePhaseLabel.vue?vue&type=script&lang=ts&"
export * from "./PipelinePhaseLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports